<div cdkDragHandle class="photo" [style.height.px]="proportionalHeight">
  <span class="span-loading">Loading...</span>
  <img
    class="image-preview"
    [src]="isAnimated ? gifUrl : previewUrl"
    [ngStyle]="{ 'object-fit': isAnimated ? 'contain' : 'cover' }"
    alt=""
  />
  <div class="flex photo-content jcsb">
    <rx-row class="photo-content-actions flex-nosize" [ngClass]="showCheckbox ? 'jcsb' : 'jcfe'">
      <mat-checkbox [checked]="checked" (change)="checkedChanged($event)" *ngIf="showCheckbox"></mat-checkbox>
      <div [rxRoleGuard]="rejectedRoles" *ngIf="showMenuHandle" class="action-controls flex flex-row flex-nosize">
        <rx-icon
          *ngIf="showMenuHandle"
          name="icon-shadow-menu"
          class="rel z1 cp"
          [class.disabled]="disableMenu"
          (click)="onMenuClicked($event)"
          [matMenuTriggerFor]="actionMenu"
          [matMenuTriggerData]="actionMenuContext"
        ></rx-icon>
      </div>
    </rx-row>

    <div class="flex flex-row jcc aic play-control" *ngIf="!isAnimated">
      <mat-icon (click)="toggleAnimation($event)"> play_circle_outline </mat-icon>
    </div>

    <div class="description">
      {{ description }}
    </div>
  </div>
</div>
